<div style="background-color: #F1F1F1;">
  <div class="container pt-5 pb-5">
    <div class="title"> <span>Linha de Produtos</span></div>
  </div>
</div>
<div class="container-md">
  <div class="l-cards">
    <a *ngFor="let category of categories" style="cursor: pointer; text-decoration: none;" href="{{category.link}}">
      <div class="card-linhas">
        <img src="{{category.cover_url}}" alt="">
      </div>
      <div class="title-linhas text-center mt-2">
        <p>{{category.nome }}</p>
      </div>
    </a>
  </div>
</div>
